<template>
  <Section>
    <template #header>
      <div class="flex items-center gap-2 text-dark-neutral-500">
        <span class="material-symbols-outlined">interests</span>
        <h2 class="font-semibold">Variants/Configurations</h2>
      </div>
      <button
        @click="onCreateVariant"
        class="bg-primary-500 hover:bg-primary-400 text-white px-2.5 py-2 rounded text-sm font-medium"
      >
        Add variant
      </button>
    </template>

    <div class="px-6 py-4 flex flex-col gap-4 w-full">
      <VariantPanel
        v-for="(variant, index) in variants"
        :key="variant.id"
        v-model="variants[index]"
        @delete="deleteVariant"
        ref="variantPanels"
      />
    </div>
  </Section>
</template>

<script setup lang="ts">
import Section from "components/Section.vue";
import VariantPanel from "./Variant.vue";
import { nextTick, useTemplateRef } from "vue";
import { useVariants } from "./useVariants";

const { variants, createVariant, deleteVariant } = useVariants();
const variantPanels = useTemplateRef("variantPanels");

async function onCreateVariant() {
  createVariant();
  await nextTick();
  variantPanels.value?.[variants.value.length - 1]?.scrollIntoView();
  variantPanels.value?.[variants.value.length - 1]?.select();
}
</script>
